
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impressum",
      function () {
        return require("private-next-pages/impressum.tsx");
      }
    ]);
  